import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header d-flex align-items-center justify-content-end" }
const _hoisted_5 = { class: "card-toolbar" }
const _hoisted_6 = { class: "d-flex gap-2 me-4" }
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "table table-tenant-sm table-hover" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = ["onClick"]

import { ref, onMounted } from "vue";
import {
  EventShopPointTransactionTypes,
  EventShopPointTransactionTypesOptions,
  EventShopPointTransactionSourceOptions,
} from "@/core/types/shop/ShopPointsTypes";
import EventsServices from "../services/EventsServices";
import RewardDetail from "../components/shop/RewardDetail.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'PointTransaction',
  setup(__props) {

const isLoading = ref(false);
const data = ref(<any>[]);
const rewardDetailRef = ref<any>(null);
const criteria = ref<any>({
  ticket: "",
  accountNumber: "",
  page: 1,
  size: 25,
  status: EventShopPointTransactionTypes.Success,
});

const accountSelected = ref(0);
const tab = ref<any>(EventShopPointTransactionTypes.Success);
const isTabActive = (_tab: any) => {
  return tab.value === _tab;
};

const changeTab = (_value: any) => {
  tab.value = _value;
  criteria.value.status = tab.value;
  if (tab.value === 5) {
    criteria.value.status = null;
  }
  fetchData(1);
};

const fetchData = async (page: number) => {
  isLoading.value = true;
  criteria.value.page = page;
  try {
    const res = await EventsServices.queryShopPointTransaction(criteria.value);
    data.value = res.data;
    criteria.value = res.criteria;
  } catch (error) {
    console.error(error);
  }
  isLoading.value = false;
};

function getStatusTag(status: EventShopPointTransactionTypes) {
  switch (status) {
    case EventShopPointTransactionTypes.Pending:
      return "warning";
    case EventShopPointTransactionTypes.Success:
      return "success";
    case EventShopPointTransactionTypes.Fail:
      return "danger";
  }
}

const getStatusLabel = (value: number) => {
  const option = EventShopPointTransactionTypesOptions.value.find(
    (option) => option.value === value
  );
  return option ? option.label : "";
};

const clearSearchCriteria = async () => {
  criteria.value = {
    ticket: "",
    accountNumber: "",
    page: 1,
    pageSize: 10,
    status: EventShopPointTransactionTypes.Success,
  };
  await fetchData(1);
};

const selectedAccount = (id: number) => {
  accountSelected.value = id;
};

onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_UserInfo = _resolveComponent("UserInfo")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_ShopPoints = _resolveComponent("ShopPoints")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(EventShopPointTransactionTypesOptions), (tab) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "nav-item",
          key: tab.value
        }, [
          _createElementVNode("a", {
            class: _normalizeClass(["nav-link text-active-primary pb-2", [
          { active: isTabActive(tab.value) },
          { 'disabled opacity-50 pe-none': isLoading.value },
        ]]),
            "data-bs-toggle": "tab",
            href: "#",
            onClick: ($event: any) => (changeTab(tab.value))
          }, _toDisplayString(tab.label), 11, _hoisted_2)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_el_input, {
              class: "w-150px",
              modelValue: criteria.value.ticket,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.ticket) = $event)),
              placeholder: "Ticket No.",
              disabled: isLoading.value,
              clearable: ""
            }, null, 8, ["modelValue", "disabled"]),
            _createVNode(_component_el_input, {
              class: "w-150px",
              modelValue: criteria.value.accountNumber,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((criteria.value.accountNumber) = $event)),
              placeholder: "Account No.",
              disabled: isLoading.value,
              clearable: ""
            }, null, 8, ["modelValue", "disabled"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (fetchData(1))),
              loading: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
              ]),
              _: 1
            }, 8, ["loading"]),
            _createVNode(_component_el_button, {
              onClick: clearSearchCriteria,
              disabled: isLoading.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.user")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.uid")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.accountNo")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.ticket")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.points")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.sourceType")), 1),
              _createElementVNode("th", null, _toDisplayString(_ctx.$t("fields.createdOn")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && data.value.length == 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_10, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id,
                      class: _normalizeClass({
              'tr-select': item.id === accountSelected.value,
            }),
                      onClick: ($event: any) => (selectedAccount(item.id))
                    }, [
                      _createElementVNode("td", null, [
                        _createVNode(_component_UserInfo, {
                          user: item.user,
                          class: "me-2"
                        }, null, 8, ["user"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_tag, {
                          type: getStatusTag(item.status)
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(getStatusLabel(item.status)), 1)
                          ]),
                          _: 2
                        }, 1032, ["type"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.targetAccountUid), 1),
                      _createElementVNode("td", null, _toDisplayString(item.source.accountNumber), 1),
                      _createElementVNode("td", null, _toDisplayString(item.ticket), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_ShopPoints, {
                          points: item.point
                        }, null, 8, ["points"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(_unref(EventShopPointTransactionSourceOptions)[item.sourceType].label), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TimeShow, {
                          type: "GMToneLiner",
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ])
                    ], 10, _hoisted_12))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(RewardDetail, {
      ref_key: "rewardDetailRef",
      ref: rewardDetailRef
    }, null, 512)
  ], 64))
}
}

})